import { SingleSelectField } from "components/RenderInput"
import React, { useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import { Field } from "redux-form"
import Flatpickr from "react-flatpickr"

const HOURS = [
  { label: "12:00AM", value: "00:00:00" },
  { label: "12:30AM", value: "00:30:00" },
  { label: "1:00AM", value: "01:00:00" },
  { label: "1:30AM", value: "01:30:00" },
  { label: "2:00AM", value: "02:00:00" },
  { label: "2:30AM", value: "02:30:00" },
  { label: "3:00AM", value: "03:00:00" },
  { label: "3:30AM", value: "03:30:00" },
  { label: "4:00AM", value: "04:00:00" },
  { label: "4:30AM", value: "04:30:00" },
  { label: "5:00AM", value: "05:00:00" },
  { label: "5:30AM", value: "05:30:00" },
  { label: "6:00AM", value: "06:00:00" },
  { label: "6:30AM", value: "06:30:00" },
  { label: "7:00AM", value: "07:00:00" },
  { label: "7:30AM", value: "07:30:00" },
  { label: "8:00AM", value: "08:00:00" },
  { label: "8:30AM", value: "08:30:00" },
  { label: "9:00AM", value: "09:00:00" },
  { label: "9:30AM", value: "09:30:00" },
  { label: "10:00AM", value: "10:00:00" },
  { label: "10:30AM", value: "10:30:00" },
  { label: "11:00AM", value: "11:00:00" },
  { label: "11:30AM", value: "11:30:00" },
  { label: "12:00PM", value: "12:00:00" },
  { label: "12:30PM", value: "12:30:00" },
  { label: "1:00PM", value: "13:00:00" },
  { label: "1:30PM", value: "13:30:00" },
  { label: "2:00PM", value: "14:00:00" },
  { label: "2:30PM", value: "14:30:00" },
  { label: "3:00PM", value: "15:00:00" },
  { label: "3:30PM", value: "15:30:00" },
  { label: "4:00PM", value: "16:00:00" },
  { label: "4:30PM", value: "16:30:00" },
  { label: "5:00PM", value: "17:00:00" },
  { label: "5:30PM", value: "17:30:00" },
  { label: "6:00PM", value: "18:00:00" },
  { label: "6:30PM", value: "18:30:00" },
  { label: "7:00PM", value: "19:00:00" },
  { label: "7:30PM", value: "19:30:00" },
  { label: "8:00PM", value: "20:00:00" },
  { label: "8:30PM", value: "20:30:00" },
  { label: "9:00PM", value: "21:00:00" },
  { label: "9:30PM", value: "21:30:00" },
  { label: "10:00PM", value: "22:00:00" },
  { label: "10:30PM", value: "22:30:00" },
  { label: "11:00PM", value: "23:00:00" },
  { label: "11:30PM", value: "23:30:00" },
]

export const renderReminderNotifications = ({ fields }) => {
  const notificationOptions = [
    {
      value: 1,
      label: "In-app notification",
    },
    {
      value: 2,
      label: "Email notification",
    },
  ]

  const durationOptions = [
    { value: 5, label: "5 min" },
    { value: 10, label: "10 min" },
    { value: 15, label: "15 min" },
    { value: 30, label: "30 min" },
    { value: 60, label: "1 hour" },
    { value: 120, label: "2 hours" },
    { value: 240, label: "4 hours" },
    { value: 360, label: "6 hours" },
    { value: 720, label: "12 hours" },
    { value: 1440, label: "1 day" },
    { value: 2880, label: "2 days" },
    { value: 10080, label: "1 week" },
  ]

  return (
    <React.Fragment>
      {fields.map((notification, index) => {
        return (
          <React.Fragment key={index}>
            <Row className={index === 0 ? "mb-3" : "my-3"}>
              <Col xs="auto">
                <div style={{ minWidth: "200px" }}>
                  <Field
                    name={`${notification}.type`}
                    component={SingleSelectField}
                    options={notificationOptions}
                    isSearchable={false}
                  />
                </div>
              </Col>
              <Col xs="auto">
                <div style={{ minWidth: "120px" }}>
                  <Field
                    name={`${notification}.time_period`}
                    component={SingleSelectField}
                    options={durationOptions}
                    isSearchable={false}
                  />
                </div>
              </Col>
              <Col xs="auto" className="mt-2">
                before start
              </Col>
              <Col xs="auto" className="mt-2">
                <i
                  className="bx bx-sm bx-x"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    fields.remove(index)
                  }}
                />
              </Col>
            </Row>
          </React.Fragment>
        )
      })}
      <Row className="mt-1">
        <Col>
          <span
            style={{ cursor: "pointer", color: "#556ee6" }}
            onClick={() => fields.push({ type: 1, time_period: 30 })}
          >
            Add Another
          </span>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export const renderWeeklyHours = ({
  fields,
  changeCheckboxValue,
  meta: { error, submitFailed },
}) => {
  return (
    <React.Fragment>
      {fields.map((weeklyHours, index) => {
        return (
          <Row key={index} className={index === 0 ? "" : "my-2"}>
            <Col xs="auto">
              <div style={{ minWidth: "120px" }}>
                <Field
                  name={`${weeklyHours}.start`}
                  component={SingleSelectField}
                  options={HOURS}
                  isSearchable={false}
                />
              </div>
            </Col>
            <Col xs="auto" className="mt-2">
              -
            </Col>
            <Col xs="auto">
              <div style={{ minWidth: "120px" }}>
                <Field
                  name={`${weeklyHours}.end`}
                  component={SingleSelectField}
                  options={HOURS}
                  isSearchable={false}
                />
              </div>
            </Col>
            <Col xs="auto" className="mt-2">
              <i
                className="bx bx-sm bx-trash"
                style={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (fields?.length === 1) {
                    changeCheckboxValue()
                  }
                  fields.remove(index)
                }}
              />
            </Col>
            <Col xs="auto" className="mt-2">
              <i
                className="bx bx-sm bx-plus"
                style={{
                  cursor: "pointer",
                }}
                onClick={() =>
                  fields.push({ start: "09:00:00", end: "17:00:00" })
                }
              />
            </Col>
          </Row>
        )
      })}
      {submitFailed && error && <span className={"input-error"}>{error}</span>}
    </React.Fragment>
  )
}

const calculateEndTime = (start = "") => {
  const values = start?.split(":")
  const startHour = parseInt(values[0])
  const startMin = parseInt(values[1])
  let endHour = 0
  let endMin = 0
  if (startMin === 30) {
    endHour = startHour === 23 ? 0 : startHour + 1
    endMin = 0
  } else if (startMin === 0) {
    endHour = startHour
    endMin = 30
  }
  return `${endHour < 10 ? `0${endHour}` : endHour}:${
    endMin === 0 ? `00` : endMin
  }:00`
}

const formatTimes = (times = []) => {
  const result = []
  if (times.length === 1) {
    result.push({ start: times[0], end: calculateEndTime(times[0]) })
  } else {
    let currentInterval = { start: times[0], end: null }
    let currentTime = times[0]
    for (let i = 1; i < times.length; i++) {
      if (calculateEndTime(currentTime) === times[i]) {
        currentTime = times[i]
        if (i === times.length - 1) {
          result.push({
            ...currentInterval,
            end: calculateEndTime(currentTime),
          })
        }
        continue
      } else {
        currentInterval.end = calculateEndTime(currentTime)
        result.push(currentInterval)
        currentTime = times[i]
        currentInterval = { start: currentTime, end: null }
      }
      if (i === times.length - 1) {
        result.push({ ...currentInterval, end: calculateEndTime(currentTime) })
      }
    }
  }
  return result
}

const sortTimes = (times = []) => {
  times.sort((a, b) => {
    const aVal = a?.split(":")
    const aHour = parseInt(aVal[0])
    const aMin = parseInt(aVal[1])
    const bVal = b?.split(":")
    const bHour = parseInt(bVal[0])
    const bMin = parseInt(bVal[1])
    if (aHour < bHour) {
      return -1
    } else if (aHour > bHour) {
      return 1
    } else {
      if (aMin < bMin) {
        return -1
      } else if (aMin > bMin) {
        return 1
      } else return 0
    }
  })
}

const DAYS = {
  1: { longName: "monday", shortName: "mon" },
  2: { longName: "tuesday", shortName: "tue" },
  3: { longName: "wednesday", shortName: "wed" },
  4: { longName: "thursday", shortName: "thu" },
  5: { longName: "friday", shortName: "fri" },
  6: { longName: "saturday", shortName: "sat" },
  7: { longName: "sunday", shortName: "sun" },
}

export const mapAvailabilityToForm = (availableTimes = []) => {
  // group available times by days
  const groupedDays = availableTimes.reduce((res, obj) => {
    let key = obj?.int_day
    if (!res[key]) {
      res[key] = []
    }
    res[key].push(obj?.hour)
    return res
  }, {})

  // sort the available times in ascending order
  for (const day in groupedDays) {
    sortTimes(groupedDays[day])
  }

  // map api data to form
  const availability = {}
  for (const day in groupedDays) {
    availability[`${DAYS[`${day}`].longName}`] = formatTimes(groupedDays[day])
  }

  return availability
}

export const mapApiToSubCalendarForm = (apiResponse = {}) => {
  const availability = {
    attendees: apiResponse?.attendees_number,
    duration: apiResponse?.duration_time,
    maxSeats: apiResponse?.max_seats_per_booking,
  }
  const weeklyHours = mapAvailabilityToForm(apiResponse?.available_times)
  const availableDays = Object.keys(weeklyHours)
  if (availableDays.length > 0) {
    for (const day in DAYS) {
      if (availableDays?.includes(DAYS[day].longName)) {
        availability[DAYS[day].shortName] = true
      }
    }
  }
  return {
    details: {
      name: apiResponse?.name,
      description: apiResponse?.description,
      timezone: apiResponse?.timezone,
      inAppNotes: apiResponse?.label_for_booking_notes,
      location: !apiResponse?.lat && !apiResponse?.lon ? "1" : "2",
      locationText:
        !apiResponse?.lat && !apiResponse?.lon ? apiResponse?.location : "",
      locationDetails: {
        lat: apiResponse?.lat,
        lng: apiResponse?.lon,
        address:
          apiResponse?.lat && apiResponse?.lon ? apiResponse?.location : "",
      },
    },
    availability: {
      ...availability,
      ...weeklyHours,
      hideEndTime: apiResponse?.hide_end_time,
      blackoutDates: apiResponse?.blackout_dates?.map(
        d => d?.date?.split(" ")[0]
      ),
      maxDaysInAdvance: apiResponse?.book_max_days_in_advance,
    },
    payment: {
      paid: !!apiResponse?.price,
      price: apiResponse?.price,
      tax: !!apiResponse?.tax || apiResponse?.tax === 0,
      taxValue: apiResponse?.tax,
      taxLabel: apiResponse?.tax_label,
    },
    communication: {
      emailConfirmation: apiResponse?.email_invite,
      reminderNotifications: apiResponse?.reminders?.map(reminder => ({
        type: reminder?.type,
        time_period: reminder?.time_period,
      })),
    },
    access: {
      accessByTags: apiResponse?.access_type === 2,
      tags: apiResponse?.tags?.map(tag => tag?.id),
    },
  }
}

const mapAvailabilityToApi = formValue => {
  const available_times = []
  for (const day in DAYS) {
    if (formValue[DAYS[day].shortName]) {
      formValue[DAYS[day].longName]?.map(x => {
        if (x?.start === "00:00:00" && x?.end === "00:00:00") {
          HOURS?.forEach(h => {
            available_times.push({
              int_day: day,
              string_day:
                DAYS[day].shortName[0].toUpperCase() +
                DAYS[day].shortName.slice(1),
              hour: h?.value,
            })
          })
        } else {
          let current_time = x?.start
          while (current_time !== x?.end) {
            available_times.push({
              int_day: day,
              string_day:
                DAYS[day].shortName[0].toUpperCase() +
                DAYS[day].shortName.slice(1),
              hour: current_time,
            })
            current_time = calculateEndTime(current_time)
          }
        }
      })
    }
  }

  return available_times
}

export const mapSubCalendarFormToApi = (data = {}) => ({
  access_type: data?.access?.accessByTags ? 2 : 1,
  attendees_number: data?.availability?.attendees,
  available_times: mapAvailabilityToApi(data?.availability),
  blackout_dates: data?.availability?.blackoutDates,
  book_max_days_in_advance: data?.availability?.maxDaysInAdvance,
  business_unit_id: data?.business_unit_id,
  calendar_id: data?.calendar_id,
  description: data?.details?.description,
  duration_time: data?.availability?.duration,
  hide_end_time: data?.availability?.hideEndTime,
  email_invite: data?.communication?.emailConfirmation,
  label_for_booking_notes: data?.details?.inAppNotes,
  lat: data?.details?.locationDetails?.lat,
  lon: data?.details?.locationDetails?.lng,
  location:
    parseInt(data?.details?.location) === 2
      ? data?.details?.locationDetails?.address
      : data?.details?.locationText,
  location_type: data?.details?.location,
  name: data?.details?.name,
  price: data?.payment?.price,
  reminders: data?.communication?.reminderNotifications,
  tag_ids: data?.access?.tags || [],
  tax: data?.payment?.taxValue,
  tax_enabled: data?.payment?.tax,
  tax_label: data?.payment?.taxLabel,
  timezone: data?.details?.timezone,
  user_id: data?.userId,
  vendor_id: data?.vendorId,
  max_seats_per_booking: data?.availability?.maxSeats,
})

export const renderBlackOutDates = ({
  input,
  label,
  meta: { touched, error },
  disabled,
  placeholder = "Add date",
}) => {
  const [dates, setDates] = useState(input.value || [])

  useEffect(() => {
    if (input.value && dates?.length === 0) {
      setDates(input.value)
    }
    if (!input.value) {
      setDates([])
    }
  }, [input.value])

  function handleChange(value) {
    setDates(value)
    input.onChange(value)
  }

  return (
    <>
      <Row>
        <Col xs="auto">
          <Flatpickr
            className="form-control bg-white"
            placeholder={placeholder}
            options={{
              altInput: true,
              altFormat: "Y-m-d",
              dateFormat: "Y-m-d",
            }}
            value={[]}
            mode="multiple"
            onChange={(date, dateStr) => {
              handleChange([...dates, dateStr])
            }}
          />
        </Col>
      </Row>
      <Row className="mt-2">
        {dates?.map((date, index) => {
          return (
            <Col xs="auto" key={index}>
              <span>{date}</span>
              <i
                className="bx bx-x font-size-20 ms-1"
                style={{
                  cursor: "pointer",
                  color: "red",
                  verticalAlign: "bottom",
                }}
                onClick={() => {
                  handleChange(dates?.filter(x => x !== date))
                }}
              />
            </Col>
          )
        })}
      </Row>
    </>
  )
}
